// extracted by mini-css-extract-plugin
module.exports = {"Border":"Divider_Border__VgAzp","BorderBlack":"Divider_BorderBlack__23F9l","BorderSmall":"Divider_BorderSmall__2XKZZ"};